import React from 'react';
import AnimatedUsps from './AnimatedUsps';
import { LetterIcon, CheckBoxIcon, TimerIcon, AddUserIcon } from './Icons';
import { jsx as _jsx } from "react/jsx-runtime";
var usps = [{
  icon: /*#__PURE__*/_jsx(LetterIcon, {}),
  text: 'Keep work and life separate by using your work email'
}, {
  icon: /*#__PURE__*/_jsx(CheckBoxIcon, {}),
  text: 'Free forever, no credit card required'
}, {
  icon: /*#__PURE__*/_jsx(TimerIcon, {}),
  text: 'Collaborate with your team within minutes'
}, {
  icon: /*#__PURE__*/_jsx(AddUserIcon, {}),
  text: 'Invite an unlimited amount of team members'
}];
export default function ProductUsps() {
  return /*#__PURE__*/_jsx(AnimatedUsps, {
    usps: usps
  });
}